import {ssrSafeLocation} from '@github-ui/ssr-utils'

const SAFE_PROTOCOLS = new Set(['http:', 'https:', 'mailto:'])

/**
 * Returns the URL if it parses and uses a safe protocol (http/https/mailto),
 * otherwise undefined. Blocks `javascript:` and `data:` URI XSS via user-controlled
 * artifact bodies. Anchor-only (`#…`) values are returned as-is.
 */
export function safeHref(url: string | undefined | null): string | undefined {
  if (!url) return undefined
  if (url.startsWith('#')) return url
  try {
    const parsed = new URL(url, ssrSafeLocation.origin)
    return SAFE_PROTOCOLS.has(parsed.protocol) ? url : undefined
  } catch {
    return undefined
  }
}
